import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export function GetDateObjectToFullIsoString(date: NgbDate): string {
  if (!date?.year || !date?.month || !date?.day) {
    return null;
  }

  const dateString = new Date(
    Date.UTC(date.year, date.month - 1, date.day)
  ).toISOString();
  return dateString;
}
